// synced from loomweb (do not edit casually; keep faithful for re-sync).
/**
 * 危险命令模式列表
 * 用于在命令执行卡片中识别并标记潜在危险操作。
 *
 * 分类：
 * - 文件删除：递归/强制删除
 * - Git 危险操作：强制推送、硬重置、清理
 * - 系统危险操作：权限放开、格式化、磁盘写入
 * - 远程代码执行：管道执行远程脚本
 * - 数据库危险操作：删表、清空表、全表删除
 * - 容器/编排危险操作：强制删除容器/镜像
 * - 网络/代理危险操作：iptables 清空、SSH 密钥覆盖
 */
export const DANGEROUS_PATTERNS: RegExp[] = [
  // ── 文件删除 ──────────────────────────────────────────────
  /\brm\s+-(r|rf|fr)\s/i,
  /\brm\s+-(r|rf|fr)$/i,

  // ── Git 危险操作 ──────────────────────────────────────────
  /\bgit\s+push\s+.*--force/i,
  /\bgit\s+push\s+-f\b/i,
  /\bgit\s+reset\s+--hard/i,
  /\bgit\s+clean\s+-[df]+/i,

  // ── 系统危险操作 ──────────────────────────────────────────
  /\bchmod\s+777\b/i,
  /\bsudo\s+rm\b/i,
  /\bmkfs\b/i,
  /\bdd\s+if=/i,

  // ── 远程代码执行 ──────────────────────────────────────────
  /\bcurl\s+.*\|\s*(bash|sh)\b/i,
  /\bwget\s+.*\|\s*(bash|sh)\b/i,

  // ── 数据库危险操作 ────────────────────────────────────────
  /\bDROP\s+(TABLE|DATABASE)\b/i,
  /\bTRUNCATE\s+TABLE\b/i,
  /\bDELETE\s+FROM\s+\w+\s*(;|$)/i,

  // ── 容器/编排危险操作 ─────────────────────────────────────
  /\bdocker\s+rm\s+-f\b/i,
  /\bdocker\s+rmi\s+-f\b/i,
  /\bdocker\s+compose\s+down\s+.*-v/i,
  /\bdocker-compose\s+down\s+.*-v/i,
  /\bkubectl\s+delete\s+.*--force\b/i,
  /\bkubectl\s+delete\s+.*--grace-period=0\b/i,

  // ── 网络/安全危险操作 ─────────────────────────────────────
  /\biptables\s+-F\b/i,
  /\btee\s+.*\.ssh\/authorized_keys\b/i,
  /\bsystemctl\s+(stop|disable)\s+(ufw|firewalld|iptables)\b/i
];

/** 检测命令是否为危险命令 */
export function isDangerousCommand(command: string): boolean {
  return DANGEROUS_PATTERNS.some((pattern) => pattern.test(command));
}
